import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, TextField, Typography } from '@mui/material';
import { ComunidadAutonoma } from './ComunidadAutonoma';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IComunidadAutonomaDeleterops {
    open: boolean;
    onClose?: Function;
    onDelete?: Function;
    id: number[];
}

export interface IComunidadAutonomaDeleteState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    openErroDialog: boolean;
}

export default class ComunidadAutonomaDelete extends React.Component<IComunidadAutonomaDeleterops, IComunidadAutonomaDeleteState> {
    _selectedItems: number[] = [];

    public constructor(props: IComunidadAutonomaDeleterops) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            openErroDialog: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IComunidadAutonomaDeleterops>, nextContext: any): void {
        this._selectedItems = nextProps.id;

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Eliminar comunidad autónoma
                    </DialogTitle>
                    <DialogContent>
                        {
                            this._selectedItems.length == 1 && (
                                `¿Desea eliminar la comunidad seleccionada?`
                            )
                        }
                        {
                            this._selectedItems.length > 1 && (
                                `¿Desea eliminar las comunidades seleccionadas?`
                            )
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Ok.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Ok() {
        this.Delete(0);
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Delete(index: number): void {
        if(index >= this._selectedItems.length) {
            this.setState(
                {
                    open: false,
                    openErroDialog: false
                }
            );

            if(this.props.onDelete != null) {
                this.props.onDelete();
            }

            return;
        }

        let url = `${Common.END_POINT}/masters/comunidadesautonomas/${this._selectedItems[index]}/delete`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: this._selectedItems[index].toString(),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.Delete(index + 1);
        }).fail(() => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
        })
    }
}